import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeAircraftLine from './ScheduleGradeAircraftLine';
import ScheduleGradeTrainingVacationLineAlternate from './ScheduleGradeTrainingVacationLineAlternate';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeTrainingVacationsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_vacations: null,
      staffs_list: [],
      width_table: '100%',
      width_table_tbody: '100%',
      date_start: '',
      date_finish: '',
      remaining_staffs_list: null,
    };
    this.add = this.add.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeRegime(name, event) {
    var self = this;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    Object.keys(self.props.schedule_used_regimes).map(function(k) {
      var sur = self.props.schedule_used_regimes[k];
      if (sur.id === event.value) {
        self.setState({start_day: sur.start_day_str});
      }
    })
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.schedule_vacations) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_vacations: newProps.schedule_vacations,
      });

      var total_days = 0;
      Object.keys(this.props.schedule_days).map(function(k) {
        total_days = total_days + 1;
      })
      var total_width_days = (70 * total_days);
      var width_table = 125 + 78 + 37 + 57 + 57 + 42 + 180 + 58 + 58 + total_width_days;
      var width_table_tbody = width_table + 16;
      width_table = width_table + 'px';
      width_table_tbody = width_table_tbody + 'px';
      this.setState({width_table: width_table});
      this.setState({width_table_tbody: width_table_tbody});
    }
    if((this.state.loaded === 0 && Array.isArray(newProps.remaining_staffs_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        remaining_staffs_list: newProps.remaining_staffs_list,
        schedule_grade_id: newProps.schedule_grade_id,
        types_list: newProps.types_list,
        loaded: 1,
      });
    }
  }

  add (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
      staff_id: this.state.staff_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      type: 'ferias',
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/treinamentos/adicionar/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Escala</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.Funcionario}:</label>
          <Select
            className="form-field-name"
            name="staff_id"
            value={this.state.staff_id}
            searchable={true}
            placeholder={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.placeholder.SelecionarFuncionario}
            onChange={this.handleSelectChange.bind(this, 'staff_id')}
            options={this.state.remaining_staffs_list}
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.DataInicial}:</label>
          <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.placeholder.DataInicial} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.DataFinal}:</label>
          <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.placeholder.DataFinal} />
        </div>
      </div>
    </div>
    <hr/>
    <div className="form-group">
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.formulario.botaoAdicionarAEscala}</button>
    </div>
  </form>
  <hr/>
  {(this.state.schedule_vacations === null || typeof this.state.schedule_vacations === 'undefined') ?  ''
  :
  <div className="table-schedule-container-simple">
    <hr/>
    <h3 className="page-title">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tituloEscala}</h3>
    <hr/>
    <table className="table table-schedule table-bordered">
      <thead>
        <tr>
          <th className="text-center"></th>
          <th className="text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tabela.Turma}</th>
          <th className="text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tabela.Nome}</th>
          <th className="text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tabela.Matricula}</th>
          <th className="text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tabela.Designação}</th>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <th>{day.weekday}</th>
            );
          })}
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <th>{day.day_simple}</th>
            );
          })}
        </tr>
      </thead>
      <tbody id="schedule-trainings">
        {Object.keys(self.state.schedule_vacations).map(function(k) {
          var sgas = self.state.schedule_vacations[k];
          return(
            <ScheduleGradeTrainingVacationLineAlternate schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id}  updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} types_list={self.props.types_list} sgas={sgas} staffs_list={self.props.remaining_staffs_list} schedule_days={self.props.schedule_days} initials_colors={self.props.initials_colors} />
          );
        })}
      </tbody>
    </table>
  </div>
  }
</div>
    );
  }
}

export default ScheduleGradeTrainingVacationsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeTrainingVacationsTab.js